export default {
  SET_FACILITY_HASH_MAP: 'SET_FACILITY_HASH_MAP',
  SET_SELECTED_ITEM_ID: 'SET_SELECTED_ITEM_ID',
  SET_SELECTED_ITEM_NAME: 'SET_SELECTED_ITEM_NAME',
  SET_SELECTED_ITEM: 'SET_SELECTED_ITEM',
  SET_ISSUE_DETAIL: 'SET_ISSUE_DETAIL',
  ADD_UPLOAD_IMAGE: 'ADD_UPLOAD_IMAGE',
  SET_UPLOAD_IMAGE: 'SET_UPLOAD_IMAGE',
  CLEAR_ISSUE: 'CLEAR_ISSUE',
}
